// Bilingual UI string dictionary
export const t = {
    he: {
        appName: "אל-אהלייה",
        appTag: "המכללה אל-אהלייה AI",
        navLanding: "דף הבית",
        navSimulator: "בוט הרישום",
        navCrm: "ניהול לידים",
        navPeda: "מרכז למידה",
        navIntegrations: "אינטגרציות",
        navSettings: "הגדרות בוט",
        adminArea: "אזור מנהלים",
        logout: "התנתק",
        langSwitch: "العربية",
        heroEyebrow: "אנחנו כאן בשבילך · אנחנו מאמינים ביכולות שלך",
        heroTitle: "אל-אהלייה",
        heroSubtitle: "אנחנו כאן בשבילך ולצידך — עד שתגשים את החלום שלך",
        heroPrimaryCta: "התחל שיחה עם יועץ הלימודים",
        heroSecondaryCta: "מרכז הלמידה",
        coursesTitle: "מסלולי הלימוד וההכוונה",
        coursesSubtitle: "אנחנו מכינים אותך ומפנים אותך למסלול המתאים — לאחר שלב ההכנה אצלנו, תתחיל את הלימודים האקדמיים במוסד המתאים בליווי שלנו.",
        statsStudents: "בוגרי המכללה",
        statsLecturers: "מרצים ומדריכים",
        statsYears: "שנות ניסיון",
        statsPlacement: "מסיימי תואר · הגבוה בארץ",
        statsVideos: "סרטוני לימוד",
        statsBank: "בנק שאלות מבחנים",
        whyTitle: "למה לבחור בנו?",
        why1: "תארים אקדמיים מוכרים",
        why1d: "כלל התואות מאושרים על ידי המל\"ג ומשרד החינוך.",
        why2: "ליווי אישי דו-לשוני",
        why2d: "סגל פדגוגי מנוסה הזמין בעברית ובערבית לאורך כל המסלול.",
        why3: "פרקטיקה בשטח",
        why3d: "התנסות מעשית בבתי ספר מובילים החל מהשנה הראשונה.",
        footer: "© 2026 המכללה הקהילתית אל-אהלייה. כל הזכויות שמורות.",
        // Bot
        botGreeting: "שלום! 👋 אני בוט הרישום של המכללה. אני כאן כדי לעזור לך למצוא את התכנית המתאימה. מה שמך המלא?",
        botAskPhone: "נעים מאוד {name}! מה מספר הטלפון שלך?",
        botAskEmail: "מצוין! מה כתובת המייל שלך? (אופציונלי)",
        botAskCourse: "באיזו תכנית אתה מתעניין?",
        botAskBagrut: "מה ממוצע הבגרות שלך? (0-120)",
        botAskPsych: "ומה ציון הפסיכומטרי שלך? (200-800) — אם אין, ניתן לדלג",
        botSummary: "תודה! סיכום הפרטים שלך:",
        botSubmit: "שלח לרישום",
        botSuccess: "תודה רבה! נציג מטעמנו יחזור אליך בהקדם. 🎉",
        botRestart: "התחל שיחה חדשה",
        skip: "דלג",
        // CRM
        crmTitle: "מערכת ניהול לידים — CRM",
        crmSubtitle: "כל הלידים, השיחות והנתונים האקדמיים במקום אחד",
        crmTotal: "סה\"כ לידים",
        crmHot: "חמים",
        crmAvgBagrut: "ממוצע בגרות",
        crmAvgPsych: "ממוצע פסיכומטרי",
        searchPlaceholder: "חיפוש לפי שם או טלפון...",
        all: "הכל",
        statusHot: "חם",
        statusWarm: "פושר",
        statusJust: "סתם שואל",
        statusUnqualified: "לא מתאים",
        statusContact: "ממתין לחזרה",
        leadDetails: "פרטי ליד",
        conversation: "יומן שיחה",
        noConversation: "לא נמצאה שיחה",
        status: "סטטוס",
        name: "שם",
        phone: "טלפון",
        email: "מייל",
        course: "תכנית",
        bagrut: "בגרות",
        psych: "פסיכומטרי",
        channel: "ערוץ",
        received: "התקבל",
        actions: "פעולות",
        delete: "מחק",
        confirmDelete: "למחוק ליד זה?",
        noLeads: "עדיין אין לידים. הלידים יופיעו כאן כשמשתמשים ירשמו דרך הבוט.",
        adminLogin: "כניסת מנהלים",
        adminLoginHint: "אזור מאובטח לסגל המכללה בלבד",
        password: "סיסמה",
        enter: "כניסה",
        wrongPassword: "סיסמה שגויה",
        // Peda
        pedaTitle: "מרכז למידה פדגוגי — PedaHub",
        pedaSubtitle: "מבחני סימולציה אקדמיים עם משוב מיידי",
        chooseCourse: "בחר תחום ללימוד",
        startQuiz: "התחל סימולציה",
        submitAnswer: "שלח תשובה",
        nextQuestion: "שאלה הבאה",
        backToCourses: "חזרה לתחומים",
        correct: "תשובה נכונה!",
        wrong: "תשובה שגויה",
        explanation: "הסבר תיאורטי",
        score: "ציון",
        questionOf: "שאלה {curr} מתוך {total}",
        quizComplete: "הסימולציה הושלמה!",
        yourScore: "הציון שלך",
        // Integrations
        intTitle: "אינטגרציות חברתיות וקישורים",
        intSubtitle: "ניהול קישורים דינמיים וקודי QR לקמפיינים",
        copyLink: "העתק קישור",
        copied: "הועתק!",
        botLandingLink: "קישור לדף הנחיתה",
        botSimLink: "קישור ישיר לבוט הרישום",
        pedaLink: "קישור למרכז הלמידה",
        scanQr: "סרוק את ה-QR לפתיחה במובייל",
    },
    ar: {
        appName: "الأهلية",
        appTag: "الأهلية AI",
        navLanding: "الصفحة الرئيسية",
        navSimulator: "بوت التسجيل",
        navCrm: "إدارة العملاء",
        navPeda: "مركز التعلم",
        navIntegrations: "التكاملات",
        navSettings: "إعدادات البوت",
        adminArea: "منطقة الإدارة",
        logout: "تسجيل خروج",
        langSwitch: "עברית",
        heroEyebrow: "نحن هنا من أجلك · نحن نؤمن بقدراتك",
        heroTitle: "الأهلية",
        heroSubtitle: "نحن هنا من أجلك ومعك حتى تحقيق حلمك",
        heroPrimaryCta: "ابدأ محادثة مع مستشار التعليم",
        heroSecondaryCta: "مركز التعلم",
        coursesTitle: "مسارات التحضير والتوجيه",
        coursesSubtitle: "نُهيِّئك ونحوِّلك إلى المسار المناسب — بعد مرحلة التحضير عندنا، تبدأ دراستك الأكاديمية في المؤسسة المناسبة بمرافقتنا.",
        statsStudents: "خرّيجو الكلية",
        statsLecturers: "محاضرون ومرشدون",
        statsYears: "سنوات خبرة",
        statsPlacement: "نسبة إتمام اللقب · الأعلى في البلاد",
        statsVideos: "فيديو تعليمي",
        statsBank: "بنك أسئلة الامتحانات",
        whyTitle: "لماذا تختارنا؟",
        why1: "درجات أكاديمية معتمدة",
        why1d: "جميع الدرجات معترف بها من قبل مجلس التعليم العالي ووزارة التربية.",
        why2: "إرشاد شخصي ثنائي اللغة",
        why2d: "طاقم تربوي متاح بالعبرية والعربية على مدار البرنامج.",
        why3: "تدريب ميداني",
        why3d: "تدريب عملي في مدارس رائدة بدءاً من السنة الأولى.",
        footer: "© 2026 الأهلية. جميع الحقوق محفوظة.",
        botGreeting: "أهلاً وسهلاً! 👋 أنا بوت التسجيل في الكلية. أنا هنا لأساعدك في إيجاد البرنامج المناسب. ما اسمك الكامل؟",
        botAskPhone: "تشرفنا {name}! ما رقم هاتفك؟",
        botAskEmail: "ممتاز! ما عنوان بريدك الإلكتروني؟ (اختياري)",
        botAskCourse: "ما البرنامج الذي تهتم به؟",
        botAskBagrut: "ما معدل البجروت؟ (0-120)",
        botAskPsych: "وما درجة البسيخومتري؟ (200-800) — يمكن التخطي",
        botSummary: "شكراً! ملخص بياناتك:",
        botSubmit: "إرسال للتسجيل",
        botSuccess: "شكراً جزيلاً! سيتواصل معك مندوبنا قريباً. 🎉",
        botRestart: "ابدأ محادثة جديدة",
        skip: "تخطي",
        crmTitle: "نظام إدارة العملاء — CRM",
        crmSubtitle: "كل العملاء، المحادثات، والبيانات الأكاديمية في مكان واحد",
        crmTotal: "إجمالي العملاء",
        crmHot: "ساخن",
        crmAvgBagrut: "متوسط البجروت",
        crmAvgPsych: "متوسط البسيخومتري",
        searchPlaceholder: "بحث بالاسم أو الهاتف...",
        all: "الكل",
        statusHot: "ساخن",
        statusWarm: "دافئ",
        statusJust: "مجرد سؤال",
        statusUnqualified: "غير مؤهل",
        statusContact: "بانتظار الاتصال",
        leadDetails: "تفاصيل العميل",
        conversation: "سجل المحادثة",
        noConversation: "لا توجد محادثة",
        status: "الحالة",
        name: "الاسم",
        phone: "الهاتف",
        email: "البريد",
        course: "البرنامج",
        bagrut: "بجروت",
        psych: "بسيخومتري",
        channel: "القناة",
        received: "تاريخ الاستلام",
        actions: "إجراءات",
        delete: "حذف",
        confirmDelete: "هل تريد حذف هذا العميل؟",
        noLeads: "لا توجد عملاء بعد. ستظهر هنا عندما يسجّل المستخدمون عبر البوت.",
        adminLogin: "تسجيل دخول المدراء",
        adminLoginHint: "منطقة آمنة لطاقم الكلية فقط",
        password: "كلمة المرور",
        enter: "دخول",
        wrongPassword: "كلمة مرور خاطئة",
        pedaTitle: "مركز التعلم التربوي — PedaHub",
        pedaSubtitle: "اختبارات محاكاة أكاديمية مع تغذية راجعة فورية",
        chooseCourse: "اختر مجال الدراسة",
        startQuiz: "ابدأ المحاكاة",
        submitAnswer: "إرسال الإجابة",
        nextQuestion: "السؤال التالي",
        backToCourses: "العودة للمجالات",
        correct: "إجابة صحيحة!",
        wrong: "إجابة خاطئة",
        explanation: "شرح نظري",
        score: "النتيجة",
        questionOf: "سؤال {curr} من {total}",
        quizComplete: "اكتملت المحاكاة!",
        yourScore: "نتيجتك",
        intTitle: "التكاملات والروابط",
        intSubtitle: "إدارة الروابط الديناميكية ورموز QR للحملات",
        copyLink: "نسخ الرابط",
        copied: "تم النسخ!",
        botLandingLink: "رابط الصفحة الرئيسية",
        botSimLink: "رابط مباشر لبوت التسجيل",
        pedaLink: "رابط مركز التعلم",
        scanQr: "امسح رمز QR للفتح على الجوال",
    },
};

export const useT = (lang) => t[lang] || t.he;
